import {useEffect, useRef} from 'react';
import {observer} from 'mobx-react';
import bundleStore from '../../../store/bundleStore';
import BundleDone from './BundleDone';

export default observer(function BundleReturn() {
    const started = useRef(false);
    useEffect(() => {
        if (started.current) return;
        started.current = true;
        bundleStore.restorePayment();
        if (bundleStore.result) return;
        const params = new URLSearchParams(window.location.search);
        const hashParams = new URLSearchParams(window.location.hash.split('?')[1]);
        const value = key => params.get(key) ?? hashParams.get(key);
        if (value('merchant_uid') === bundleStore.payment?.bundle && (value('imp_uid') || value('imp_success') === 'false' || value('error_code'))) {
            bundleStore.finishPayment({success: value('imp_success') !== 'false' && !value('error_code'), imp_uid: value('imp_uid')});
        } else {
            bundleStore.refreshStatus();
        }
    }, []);
    const complete = !!bundleStore.result;
    const released = bundleStore.error === '결제가 취소되었습니다.';
    const failed = !released && !!bundleStore.error && !bundleStore.error.startsWith('결제 확인 중');
    const goHome = () => {
        localStorage.removeItem('userToken');
        bundleStore.reset();
        window.location.replace(window.location.pathname);
    };
    return <div className="confirm bundle-done">
        {complete ? <BundleDone onHome={goHome} /> : <>
            <header className="bundle-done-card bundle-done-header" role="status">
                <h1>{released ? '결제 취소됨' : failed ? '결제 확인 실패' : '결제 확인 중'}</h1>
                <p className="bundle-done-caption">{released ? '결제가 취소되었습니다.' : failed
                    ? '결제 결과를 확인하지 못했습니다. 재결제하지 말고 지점으로 문의해주세요.'
                    : '결제 결과를 확인하고 있습니다. 잠시 후 다시 확인해주세요.'}</p>
            </header>
            <div className="reserved_btn bundle-done-actions">
                {!released && <button type="button" disabled={bundleStore.checkingStatus} onClick={() => bundleStore.refreshStatus()}>다시 확인</button>}
                {(failed || released) && <button type="button" className="bundle-done-home" onClick={goHome}>홈으로</button>}
            </div>
        </>}
    </div>;
});
